import ModelTypeConstants from 'constants/ModelTypeConstants';
import getNotePartType from 'notebook/notes/util/getNotePartType';
import {getStructuredTableAdapters} from 'notebook/structured-tables/StructuredTableAdapters';
import {TABLE_OPS} from 'notebook/tables/augmentNotePartTablesWithValues';
import {NotePart, NotePartWithItem} from 'notebook/util/NoteUtilConstants';
import {NoteLinkedAssayData} from 'runs/AttachmentConstants';

export function getNumberOfRowsInNotePart(notePart: NotePart, fileId: string): number {
  const type = getNotePartType(notePart);
  if (type == null || (!TABLE_OPS[type] && !(type === ModelTypeConstants.NOTE_LINKED_ASSAY_DATA))) {
    return 0;
  }

  // NLADs are note parts with potentially both data tables and structured tables and we should check for both
  if (type === ModelTypeConstants.NOTE_LINKED_ASSAY_DATA) {
    let sum = 0;
    (notePart as NotePartWithItem<NoteLinkedAssayData>).item.dataTables.forEach((dataTable) => {
      sum += dataTable.rows.length;
    });
    (notePart as NotePartWithItem<NoteLinkedAssayData>).item.versionedData.structuredTables.forEach(
      (structuredTable) => {
        const structuredTableAdapter = getStructuredTableAdapters()[structuredTable.kind];
        sum += structuredTableAdapter.toTable(structuredTable).table.length;
      }
    );

    return sum;
  }
  const table = TABLE_OPS[type].extractTable(notePart, fileId, /* stageRuns */ []);
  return table.table.length;
}
